import { connect } from "react-redux";

import { fetchSettings } from "containers/GlobalSettings/actions";
import DonationGuidelines from "./component";

import { setFormData, nextStep, previousStep } from "../pickup-form.actions";

const mapStateToProps = (state) => ({
  previousStep,
  nextStep,
  infoPage:
    state.settings.globalSettings?.find(
      (setting) => setting.label === "info-page"
    )?.value || "",
  settingsLoaded: state.settings.globalSettings.complete,
});

const mapDispatchToProps = { fetchSettings };

export default connect(mapStateToProps, mapDispatchToProps)(DonationGuidelines);
